import React from 'react';

class FakeLabel extends React.Component {
  render() {
    return (
      <label
        className={`fake-label ${
          this.props.required === true ? 'required' : ''
        }`}
      >
        {this.props.children}
      </label>
    );
  }
}

export default FakeLabel;
